import * as angular from 'angular';

interface IScope extends ng.IScope {
  window: ng.IWindowService;
  boolChangeClass: boolean;
}

export class Scroll implements ng.IDirective {
  public restrict = 'A';
  public controller: any = ScrollController;
  public link(scope: IScope, elem: JQuery, attrs: ng.IAttributes) {
    let window = angular.element(scope.window);
    window.bind("scroll", ()=> {
         if (scope.window.pageYOffset >= 90) {
             scope.boolChangeClass = true;
         } else {
             scope.boolChangeClass = false;
         }
        scope.$apply();
    });
  }
}

export class ScrollController {
  public static $inject = ["$scope","$window"];

  constructor ($scope: IScope, $window: ng.IWindowService) {
    $scope.window = $window
  }
}
